import React from 'react'
import '../css/cgvente.css';
import logo from '../image/logos.png';


function MentionLegales() {
  return (

    <div className='fontPage container'>
         <div className="logo-dash">
          <a href="/">
            <img src={logo} width="40%" height="40%" alt="logo" />
          </a>
        </div>
        <h1 className='mt-3'>mentions légales</h1>
        <h2 className="section-title">Informations techniques</h2>
        <ul>
                Editeur nom commercial : ANNONCE LEGALE OFFICIELLE – Sigle ALO
        </ul>
      
        <p className='textstyle'>SAS SEC inscrit au RCS de BORDEAUX sous le numéro 979 867 298.</p>
        <ul>ANNONCE LEGALE OFFICIELLE</ul>
        <p className='textstyle'>Tel : 0188 844 844</p>
        <p className='textstyle'>Email : service-clients@annonce-legale-officielle.fr</p> 
        <ul>
                </ul>       
        <ul>
                <li>
                Tel : 0188 844 844
                </li>
                <li>
                Email : service-clients@annonce-legale-officielle.fr
                </li>
                <li>
                       <span> Site web : <a href="https://www.annonce-legale-officielle.fr">https://www.annonce-legale-officielle.fr</a> </span>
                </li>
        </ul>
        <h2 className="section-title">Informations légales :</h2>
        <h3 className="section-title">Droits de Propriété Intellectuelle : </h3>
            <p>
                    ANNONCE LEGALE OFFICIELLE et son emblème sont des marques enregistrées et protégées par le droit de la propriété intellectuelle.
            </p>
            <p>
                    Les logos et dénominations des entreprises mentionnées sur le site <a href=''>ANNONCE LEGALE OFFICIELLE.fr </a> appartiennent exclusivement à leurs propriétaires légitimes.
            </p>
            <p>
                    Toute forme de représentation ou reproduction, partielle ou intégrale, de ces marques est strictement interdite sans un consentement écrit préalable de la part de leurs détenteurs.
            </p>
            <h2 className="section-title">Droits Relatifs à Vos Données Personnelles :</h2>
            <p>
                    Vos données personnelles sont conservées sur nos serveurs sécurisés. Conformément à la loi relative à l’informatique, aux fichiers et aux libertés du 6 janvier 1978, vous bénéficiez d’un droit d’accès, de modification, de rectification et de suppression des informations qui vous concernent.
            </p>
            <p>
                    Ce droit peut être exercé en adressant un courrier à l’adresse indiquée précédemment.
            </p>

    </div>

    // <div>MentionLegales</div>
  )
}

export default MentionLegales